import { Link } from 'react-router-dom';
import ScrollReveal from '../../../components/ui/ScrollReveal';

export default function AboutSection() {
  return (
    <section className="bg-[#faf8f5] py-16 lg:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Image */}
          <ScrollReveal>
            <div className="relative h-[560px] rounded-2xl overflow-hidden shadow-2xl shadow-stone-200">
              <img
                src="/images/Laura_3_edited.jpg"
                alt="Laura Martin — Personal Trainer London"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
              {/* Floating badge */}
              <div className="absolute bottom-8 left-8 bg-[#c9a96e] px-5 py-3 rounded-xl shadow-lg">
                <p className="text-white text-[9px] tracking-[0.25em] uppercase font-sans font-semibold">REPs Certified</p>
                <p className="text-white font-semibold text-xl leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Level 3 PT</p>
              </div>
            </div>
          </ScrollReveal>

          {/* Content */}
          <div>
            <ScrollReveal delay={100}>
              <div className="flex items-center gap-4 mb-5">
                <span className="w-8 h-px bg-[#c9a96e]" />
                <span className="text-[#c9a96e] text-[10px] font-sans font-semibold tracking-[0.32em] uppercase">About Laura</span>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={170}>
              <h2
                className="text-stone-900 mb-6"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2.4rem, 4.5vw, 3.8rem)', fontWeight: 600, lineHeight: 1.05 }}
              >
                Certified. Passionate.
                <br />
                <em className="text-[#c9a96e] not-italic">Results-Driven.</em>
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={240}>
              <p className="text-stone-600 font-sans text-base leading-relaxed mb-4">
                Laura is a London-based personal trainer and nutrition coach whose professional dance career gives her a unique understanding of body mechanics, discipline, and performance.
              </p>
              <p className="text-stone-600 font-sans text-base leading-relaxed mb-10">
                With 5,000+ coaching hours and a track record of transforming hundreds of clients, she brings precision, empathy, and genuine accountability to every session — whether in-person across London or online worldwide.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="flex flex-wrap items-center gap-4">
                <Link to="/about" className="px-7 py-3 bg-[#c9a96e] text-white text-[10px] font-sans font-bold tracking-[0.28em] uppercase rounded-full hover:bg-[#a8863f] hover:shadow-lg hover:shadow-[#c9a96e]/25 hover:-translate-y-0.5 transition-all duration-300">
                  My Story
                </Link>
                <Link to="/contact" className="px-7 py-3 border border-stone-300 text-stone-700 text-[10px] font-sans font-bold tracking-[0.28em] uppercase rounded-full hover:border-stone-500 hover:bg-stone-100 transition-all duration-300">
                  Free Consult
                </Link>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}
